export default __webpack_public_path__ + "static/media/Blog3_2.8c39a7e7.jpg";